import { Checkbox, TextField } from "@material-ui/core";
import axios from "../../../axios";
import React, { useEffect, useState, useContext } from "react";
import Button from "react-bootstrap/Button";
import Button1 from "@mui/material/Button";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import FlagIcon from "@mui/icons-material/Flag";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ProjectManageAccess from "./ProjectManageAccess";
import ManageAccess from "./ManageAccess";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import SwitchAccessShortcutAddIcon from "@mui/icons-material/SwitchAccessShortcutAdd";
import MaterialTable from "material-table";
import Team from "../../KanbanBoard/Team";
import Tooltip from "@mui/material/Tooltip";
import { Flex, Tag } from "antd";
import CustomDatePicker from "./CustomDatePicker.css";
import PatchedPagination from "../../../PatchedPagination";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tabs,
  Tab,
} from "@material-ui/core";
import "./addnewproject.css";
import {
  Col,
  Row,
  Container,
  CardBody,
  Table,
  Card,
  Progress,
} from "reactstrap";
import DateFnsUtils from "@date-io/date-fns";
import { Modal } from "react-bootstrap";
import Editproject from "./EditProject";
import Reportallocation from "./Report";
import ProjectAllocation from "./ProjectAllocation";
import ProjectInAllocation from "./ProjectinAllocation";
import Allocationseamless from "./Allocationseamless";
import ReportTeamallocate from "./ReportTeamallocate";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import moment from "moment";
import { toast, Slide } from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import { Form, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { message } from "antd";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import UserContext from "../../../index";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import AssessmentIcon from "@mui/icons-material/Assessment";
// import DoneIcon from "@mui/icons-material/Done";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Divider } from "@mui/material";
import styled from "@mui/material/styles/styled";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { linearProgressClasses } from "@mui/material/LinearProgress";
import {
  HANDLE_ON_CHANGE,
  PROJECTCREATE,
} from "../../../../src/redux/CommonInitialsate";
import createcategory from "../../../createcategory";
import Select from "react-select";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ProjectModules from "./ProjectModules";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
// import { HANDLE_ON_CHANGE } from "../../../redux/CommonInitialsate";

const Addnewproject = ({ prjallocation, setprjallocation }) => {
  let id =
    localStorage.getItem("clientid") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("clientid"));
  let initialValue = {};
  let rolecode =
    localStorage.getItem("Rolecode") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("Rolecode"));
  let userdetails =
    localStorage.getItem("clientdetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("clientdetails"));
  let createdby =
    localStorage.getItem("Empdetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("Empdetails"));
  let projects =
    localStorage.getItem("Orgsubscriptiondetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("Orgsubscriptiondetails"));

  let empid =
    localStorage.getItem("Empdetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("Empdetails"));
  let projectslength = projects?.map((e) => e.PlanCap?.Projects);
  const username =
    localStorage.getItem("username") == undefined
      ? ""
      : JSON.parse(localStorage.getItem("username"));

  const email =
    localStorage.getItem("email") == undefined
      ? ""
      : JSON.parse(localStorage.getItem("email"));
  let clientd = JSON.parse(localStorage.getItem("clientid"));
  const newDate = new Date(); // Create a new Date object to avoid modifying the original date
  const [projectnames, setProjectName] = useState("");
  // const [projectdetails, setProjectdetails] = useState([]);

  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedDate2, handleDateChange2] = useState(
    newDate.setMonth(newDate.getMonth() + 6)
  );
  const [selectedRow, setSelectedRow] = useState(null);
  const [allocationopen, setallocationopen] = useState(false);
  const [Values, setValues] = useState(initialValue);
  const [error, seterror] = useState({});
  const [dateerror, setdateerror] = useState("");
  const [row, setrow] = useState("");
  const [editopen, setedit] = useState(false);
  const [seamlessopen, setseamlessopen] = useState(false);
  const [Access, setAccess] = useState(false);
  const [Report, setReport] = useState(false);
  const [ProAllocateModal, setProAllocateModal] = useState(
    prjallocation == true ? true : false
  );

  const [inviteuser, setinviteuser] = useState(false);
  const [manageaccess, setmanageaccess] = useState(false);
  const [number, setNumber] = useState("");
  const [employee, setEmployee] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const contextval = useContext(UserContext);
  const dispatch = useDispatch();
  const { openProCreate, KanbanBoardData, projectdetails, dateformat,EmpDropDownData } =
    useSelector((state) => state.user);
  const [allocateEmployee, setAllocateEmployee] = useState([]);
  let crtid = empid[0]?.ClientUserId;
  let clientdetails =
    JSON.parse(localStorage.getItem("clientdetails")) == undefined
      ? ""
      : JSON.parse(localStorage.getItem("clientdetails"));
  const [checkSubmit, setSubmitCheck] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [projectOptions, setProjectOptions] = useState("");
  const [Projroledata, setProjroledata] = useState([]);
  const [overallCount, setOverallcount] = useState([]);
  const [selectedProject, setSelectedProject] = useState({
    label: "New Project",
    value: "new",
    data: "",
  });

  const [modules, setModules] = useState([
    {
      Name: "",
      Type: "Monolith",
      FullName: "",
    },
  ]);
  const [activeTab, setActiveTab] = useState(0);


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const { projectRole, projectRoleName, projectDetails } = useSelector(
    (state) => state.user
  );
  const useStyles = makeStyles((theme) => ({
    popover: {
      pointerEvents: "none",
    },
    paper: {
      padding: theme.spacing(1),
    },
  }));
  useEffect(() => {
    contextval.setwindows("project");
    axios
      .get(
        "subscription_user_role_mapping?ProductDetails->>ProdId=eq.11004&ClientId=eq." +
          id +
          "&LoginEnabled=eq.Y"
      )
      .then((res) => {
        let getdata = res.data;
        let filteredData = [];
        // console.log(getdata, "getdata")
        axios
          .get("subscription_client_users?ClientId=eq." + id + "&IsActive=eq.Y")
          .then((re) => {
            let userdata = re.data;
            getdata.map((e) => {
              // console.log(userdata, e, "userdata")
              let check = userdata.filter((x) => x.ClientUserId == e.UserId);
              // console.log(userdata.filter((x) => x.ClientUserId == e.UserId), "userdata", check.length != 0)
              if (check.length != 0) {
                filteredData.push(e);
              }
            });
            // console.log(filteredData, "filtereddata")
            setEmployee(filteredData);

            axios
              .get(`agilesaas_project_mapping?ClientId=eq.${id}&IsCurrent=eq.Y`)
              .then((res) => {
                setProjroledata(res.data);
              });
          });
      })

      .catch((err) => {
        console.log(err);
      });
  }, [ProAllocateModal]);

  const userorg = userdetails[0]?.OrgDetails;
  const userdet = userdetails[0]?.UserDetails;

  const employeeOption =
    employee?.length == 0
      ? []
      : employee
          ?.filter((e) => e.RoleDetails.RoleCode === "KA")
          ?.map((emp) => {
            return {
              value: emp.UserId,
              label: emp.UserDetails.Firstname + " " + emp.UserDetails.Lastname,
              pertec: Projroledata.filter(
                (ge) => ge.TeamMemberId === emp.UserId
              )
                .map((e) => parseInt(e.AllocPercentage, 10))
                .reduce((acc, val) => acc + val, 0),
            };
          });
  //this for project details check according to plancap
  const lastcode = projectdetails
    ?.map((e) => e.ProjectId)
    .sort()
    .slice(-1)
    .toString();

  const check = projectdetails?.map((e) => e.ProjectId).length;
  // const Development = projectdetails?.map((e) => e.ClientId).length;
  // console.log(projectdetails);
  // const Developmentcount = devCount
  //   ?.map((e) => e.ProjectId)
  //   ?.filter((e) => e.StageCode == "devlopment" && "User Acceptace Testing");
  // console.log(Developmentcount);

  const developmentCount = overallCount
    ?.flatMap((e) => e.CurrentStage)
    ?.filter((e) => e.StageCode === "DEV" || e.StageCode === "UAT")?.length;

  // console.log(developmentCount);

  const taskCount = overallCount
    ?.flatMap((e) => e.CurrentStage)
    ?.filter((e) => e.StageCode === "RFD" || e.StageCode === "BLG")?.length;
  // console.log(taskCount);

  useEffect(() => {
    axios
      .get(
        `agilesaas_issue_details?select=IssueTitle,CurrentStage,ProjectId&ClientId=eq.${id}&IsActive=eq.Y&CurrentStage->0->>StageCode=in.(DEV,UAT,RFD,BLG,DONE)`
      )
      .then((res) => {
        setOverallcount(res.data);
        // console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // console.log(overallCount);

  useEffect(() => {
    axios
      .get(`agilesaas_project_master?ClientId=eq.` + id)
      .then((res) => {
        // console.log(res.data);
        setProjectOptions(res.data);
        setIsLoading(false);
        // setProjectdetails(
        //   res.data.map((e) => {
        //     return { ...e, selectOption: false };
        //   })
        // );
        dispatch(
          HANDLE_ON_CHANGE({
            name: "projectdetails",
            value: res.data.map((e) => {
              return { ...e, selectOption: false };
            }),
          })
        );

        // setNumber(res.data.map((e)=>e.ProjectShortCode, 10))
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }, []);

  const poptions = projectOptions?.length > 0 && [
    { label: "New Project", value: "new", data: "" },
    ...projectOptions?.map((x) => ({
      label: x?.ProjectName,
      value: x?.ProjectId,
      data: x,
    })),
  ];

  function ProjectClose() {
    setSelectedProject({ label: "New Project", value: "new", data: "" });
    dispatch(PROJECTCREATE(false));
    const newDate = new Date();
    // setopenProCreate(false);
    setProjectName("");
    seterror({});
    handleDateChange(new Date());
    setActiveTab(0);
    handleDateChange2(newDate.setMonth(newDate.getMonth() + 6));
    setdateerror("");
    setModules([
      {
        Name: "",
        Type: "Monolith",
        FullName: "",
      },
    ]);
  }

  function AllocateClose() {
    setProAllocateModal(false);
    dispatch(PROJECTCREATE(false));
    if (prjallocation !== undefined) {
      setprjallocation(false);
    }
  }

  const validateForm = () => {
    const newErrors = {};

    if (selectedProject?.value == "new" && projectnames.trim() == "") {
      newErrors.projectnames = "Enter the project name";
    } else if (
      moment(selectedDate2).diff(moment(selectedDate), "days") == 0 ||
      moment(selectedDate2).diff(moment(selectedDate), "days") < 0
    ) {
      setdateerror("Please check Dates-StartDate should be lower than EndDate");
      newErrors.selectedDate =
        "Please check Dates-StartDate should be lower than EndDate";
      // } else if (projectslength <= check) {
      //   toast.error(
      //     `You have exceeded the minimal plan please upgrade to higher plan Further... `,
      //     {
      //       transition: Slide,
      //       position: toast.POSITION.TOP_RIGHT,
      //       autoClose: 8000,
      //       draggable: true,
      //     }
      //   );
    }

    seterror(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  // const uniqueClientIds = new Set(projectdetails.map(project => project.ClientId));
  // const totalClients = uniqueClientIds.size;
  console.log(projectdetails);
  const projectccode = projectdetails?.find(
    (e) => e.ProjectName === projectnames
  )?.ProjectId;

  const handleprojectname = (e) => {
    let text = e.target.value;

    setProjectName(text);
    setModules((prevModules) =>
      prevModules.map((module) => ({
        ...module,
        Name: text.replace(/\s+/g, "").replace(/[^a-zA-Z0-9]/g, ""),
        FullName: `${text.replace(/\s+/g, "").replace(/[^a-zA-Z0-9]/g, "")}_${
          modules?.[0]?.Type
        }`,
      }))
    );
  };

  function Refresh() {
    setSelectedProject({ label: "New Project", value: "new", data: "" });
    const newDate = new Date();
    axios.get(`agilesaas_project_master?ClientId=eq.` + id).then((res) => {
      // setProjectdetails(res.data);
      dispatch(
        HANDLE_ON_CHANGE({
          name: "projectdetails",
          value: res.data,
        })
      );
      setProjectOptions(res.data);
    });
    setdateerror("");
    setProjectName("");
    // setseamlessopen(false);
    handleDateChange(new Date());
    handleDateChange2(newDate.setMonth(newDate.getMonth() + 6));
    setModules([
      {
        Name: "",
        Type: "Monolith",
        FullName: "",
      },
    ]);
    // dispatch(PROJECTCREATE(false));
  }

  const handleEditing = (e) => {
    setedit(true);
    setrow(e);
    setModules(
      e?.ProjectModules
        ? e?.ProjectModules
        : [
            {
              Name: "",
              Type: "Monolith",
              FullName: "",
            },
          ]
    );
  };

  const handleallocation = () => {
    setallocationopen(true);
  };

  const handleReport = (e) => {
    setReport(true);
    setrow(e);
  };
  const handleaccess = (e) => {
    setAccess(true);
    setrow(e);
  };
  function refresh() {
    axios.get(`agilesaas_project_master?ClientId=eq.` + id).then((res) => {
      // setProjectdetails(res.data);
      dispatch(HANDLE_ON_CHANGE({ name: "projectdetails", value: res.data }));
    });
  }
  const handleDefaultProject = (id) => {
    // console.log(id);
    let patchdata = { IsDefault: "Y" };
    axios
      .patch(
        `agilesaas_project_master?ClientId=eq.${clientd}&ProjectId=eq.${id}`,
        patchdata
      )
      .then((res) => {
        refresh();
        dispatch(
          HANDLE_ON_CHANGE({ name: "projectdefaultrefresh", value: id })
        );
        let patchdata2 = { IsDefault: "N" };
        message.success("Data has been updated");

        axios
          .patch(
            `agilesaas_project_master?ClientId=eq.${clientd}&ProjectId=neq.${id}`,
            patchdata2
          )
          .then((res) => {
            refresh();
            console.log(res.data);
          })
          .catch((error) => {
            console.error(error);
            // message.error("Failed to update the record !!");
          });
      })
      .catch((error) => {
        console.error(error);
        message.error("Failed to update the record !!");
      });
  };
  function submit(e) {
    // modules.forEach(module => {
    //   // Check if both Name and Type are filled
    //   if (module.Name && module.Type) {
    //     // Combine Name and Type into FullName
    //     module.FullName = module.FullName ? module.FullName : `${module.Name}_${module.Type}`;
    //   }
    // })
    axios.get(`agilesaas_project_master?ClientId=eq.` + id).then((res) => {
      const pdname = res?.data?.map((x) =>
        x.ProjectName?.replace(/\s+/g, "")?.replace(/[^a-zA-Z0-9]/g, "")
      );
      // console.log(
      //   pdname.includes(
      //     projectnames?.replace(/\s+/g, "")?.replace(/[^a-zA-Z0-9]/g, "")
      //   )
      // );
      let prjcode = res.data
        ?.filter((e) => e.ProjectId)
        .sort()
        .slice(-1);
      let code = prjcode[0]?.ProjectShortCode;

      const numericPart = parseInt(code?.slice(4), 10) + 1;

      // Pad the numeric part with zeros to maintain the format
      const nextNumericPart = String(numericPart).padStart(6, "0");

      // Create the next code

      setNumber(`${projectnames?.slice(0, 4)}${nextNumericPart}`);

      // }
      // else{
      //   // const prefix = projectnames.slice(0, 4);
      //   setNumber(`${projectnames.slice(0, 4)}${"000001"}`)
      // }

      const chectknm =
        res.data.length != 0
          ? `${projectnames?.slice(0, 4)}${nextNumericPart}`
          : `${projectnames.slice(0, 4)}${"000001"}`;

      //   const generatedString = `${prefix}${number.toString()}`;
      //   setNumber(number + 1);
      // console.log(generatedString,"generatedstringf")

      e.preventDefault();
      let postdata = {
        ProjectShortCode: chectknm,
        ProjectName: projectnames,
        ClientId: id,
        ClientDetails: {
          Company: userorg?.Company,
          ContactName: userorg?.ContactName,
          ContactDesignation: userorg?.ContactDesignation,
          ContactEmail: userorg?.ContactEmail,
          ContactPhone: userorg?.ContactPhone,
        },
        CreatedDate: moment().format("YYYY-MM-DD"),
        CreatedBy: empid[0]?.ClientUserId,
        CreatedByDetails: {
          Name: username,
          Role: rolecode,
          Email: userdet?.Email,
          Phone: userorg?.ContactPhone,
        },
        StartDate: moment(selectedDate).format("YYYY-MM-DD"),
        EndDate: moment(selectedDate2).format("YYYY-MM-DD"),
        IsActive: "Y",
        Status: null,
        ProjectModules: modules,
      };
      // console.log(postdata, "postdata")
      if (projectslength <= check) {
        toast.error(
          `You have exceeded the minimal plan please upgrade to higher plan Further... `,
          {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
            draggable: true,
          }
        );
      } else if (!modules.every((module) => module.Name && module.Type)) {
        toast.error(`Please enter all the module details `, {
          transition: Slide,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
          draggable: true,
        });
      } else {
        // console.log(postdata)
        if (validateForm()) {
          if (
            modules.length > 0 &&
            [...new Set(modules?.map((item) => item.FullName))]?.length !=
              modules?.length
          ) {
            toast.error(
              `Please provide each module's full name as a unique name. `,
              {
                transition: Slide,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 8000,
                draggable: true,
              }
            );
          } else if (pdname.includes(projectnames)) {
            toast.error(`Project is already created for this name. `, {
              transition: Slide,
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 8000,
              draggable: true,
            });
          } else {
            setSubmitCheck(true);
            if (selectedProject?.value == "new") {
              axios
                .post(`agilesaas_project_master`, postdata)

                .then((response) => {
                  //add category in a api while create a project
                  createcategory(projectnames);
                  setSubmitCheck(false);
                  axios
                    .get(`agilesaas_project_master?ClientId=eq.` + id)
                    .then((res) => {
                      // Initialize variables to store the most recent project's details
                      let latestProjects = [];
                      let latestCreatedDate = ""; // Initialize as an empty string

                      // Loop through the projects
                      for (const project of res.data) {
                        // Compare the current project's creation date to the latest created date
                        if (project.CreatedDate > latestCreatedDate) {
                          // If this project has a later creation date, reset the latest projects array
                          latestProjects = [project];
                          latestCreatedDate = project.CreatedDate;
                        } else if (project.CreatedDate === latestCreatedDate) {
                          // If this project has the same creation date as the latest, add it to the array
                          latestProjects.push(project.ProjectId);
                        }
                      }

                      // Find the project with the latest "ProjectId" among the latest projects
                      let lastUpdatedProject = latestProjects?.reduce(
                        (prev, current) => {
                          return prev.ProjectId > current.ProjectId
                            ? prev
                            : current;
                        }
                      );
                      let coeprj = lastUpdatedProject?.ProjectId;
                      const newDate = new Date();
                      let initialValue = {
                        TeamMemberId: empid[0]?.ClientUserId,
                        ProjectCode:
                          coeprj == undefined ? lastUpdatedProject : coeprj,
                        ProjectStartDate: new Date(selectedDate),
                        ProjectEndDate: new Date(selectedDate2),
                        ManagerId: createdby[0]?.ClientUserId,
                        AllocPercentage: 100,
                        ProjectRole: {
                          RoleGroupId: "1",
                          RoleCode: "SM",
                          RoleName: "Scrum Master",
                        },
                        MappedBy: createdby[0]?.ClientUserId,
                        MappedByDetails: {
                          ContactName: username,
                          ContactDesignation:
                            userdetails[0]?.RoleDetails?.RoleCode,
                          ContactEmail: userdetails[0]?.UserDetails?.Email,
                          ContactPhone:
                            userdetails[0]?.OrgDetails?.ContactPhone,
                        },
                        IsCurrent: "Y",
                        Status: null,
                        ClientId: id,
                      };
                      axios
                        .post("agilesaas_project_mapping", initialValue)
                        .then((res) => {
                          toast.success(`Project On-Boarded`, {
                            transition: Slide,
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000,
                            draggable: true,
                          });
                          let requrireddata = {
                            ClientUserId: createdby?.[0]?.ClientUserId,
                            ClientId: clientd,
                            ClientDetails: {
                              Company: userorg?.Company,
                              ContactName: userorg?.ContactName,
                              ContactDesignation: userorg?.ContactDesignation,
                              ContactEmail: userorg?.ContactEmail,
                              ContactPhone: userorg?.ContactPhone,
                            },
                            DepartmentDetails:
                              createdby?.[0]?.DepartmentDetails,
                            DepartmentCode: null,
                            TentantId: "",
                            FromSenderId: "no-reply@yozytech.com",
                            ToEmailIds: {
                              emailids: email,
                            },
                            CcEmailIds: {
                              emailids: [
                                "agileteam@yozytech.com",
                                "support@yozytech.com",
                              ],
                            },
                            BccEmailIds: "",
                            EmailType: "Project Created",
                            ProductDetails: {
                              ProdId: "11004",
                              ProdName: "KANBAN",
                              Domain: "KANBAN.yozytech.com",
                            },
                            EmailSubject: "Project Created Notification",
                            IsSuccess: "Y",
                            IsPartiallyFailed: " ",
                            SendRetryHistory: "",
                            IsActive: " ",
                            Status: "",
                            EmailTemplateName: "Projectcreation",
                            emailnotify: true,
                            webnotify: true,
                            EmailTemplateVariables: {
                              xxasignbyxx: "",
                              xxassigndatexx: "",
                              xxnotifytimexx: moment().format(
                                "YYYY-MM-DDTHH:mm:ss"
                              ),
                              xxprjdisxx: "",
                              xxprjnamexx: projectnames,
                              xxstoryNamexx: "",
                              xxprjpercenxx: "",
                              xxprjstartdatexx:
                                moment(selectedDate).format("YYYY-MM-DD"),
                              xxprjenddataexx:
                                moment(selectedDate2).format("YYYY-MM-DD"),
                              xxteamnamexx: "",
                              xxsprintxx: "",
                              xxmanagernamexx: username,
                              xxcompanyname: userorg?.Company,
                              xxmanagerdesigxx: username,
                              xxgmailxx: userorg?.ContactEmail,
                              xxphnoxx: userorg?.ContactPhone,
                              webappdescri: `${projectnames} Projectcreated by ${username} `,
                            },
                          };
                          console.log(requrireddata, "nandri to email");
                          axios({
                            url: `${process.env.REACT_APP_API_BASE_URL}/api/agile/email`,
                            method: "post",
                            data: requrireddata,
                            headers: {
                              origin: process.env.REACT_APP_KANBAN_ORIGIN,
                              "Content-Type": "application/json",
                            },
                          })
                            .then((res) => {
                              console.log(res.data, "success");
                            })
                            .catch((err) => {
                              console.log(err, "fail");
                            });
                        });
                    });
                  Refresh();
                  seterror({});
                  // setopenProCreate(false);
                  // setseamlessopen(true);
                  // handleClose();
                })
                .catch((err) => {
                  // console.log(err)
                  setSubmitCheck(false);
                });

              // dispatch(PROJECTCREATE(false));
              // setseamlessopen(true);
            } else {
              let patchdata = {
                // ProjectName: projectnames,
                StartDate: moment(selectedDate).format("YYYY-MM-DD"),
                EndDate: moment(selectedDate2).format("YYYY-MM-DD"),
                ProjectModules: modules,
              };
              axios
                .patch(
                  `agilesaas_project_master?ProjectId=eq.${selectedProject?.data?.ProjectId}`,
                  patchdata
                )
                .then((res) => {
                  Refresh();
                  seterror({});
                  setSubmitCheck(false);
                  toast.success(`Project edited successfully`, {
                    position: toast.TOP_RIGHT,
                    autoClose: 3000,
                    draggable: true,
                  });
                })
                .catch((e) => {
                  setSubmitCheck(false);
                });
            }
          }
        }
      }
    });
  }

  function remove(rowData) {
    alert("are you sure want to delete");
    axios
      .delete("agilesaas_project_master?ProjectId=eq." + rowData.ProjectId)
      .then((res) => {
        // createcategory(projectnames, id, "delete")
        if (res.status === 204) {
          toast.success(`Deleted successfully`, {
            position: toast.TOP_RIGHT,
            autoClose: 3000,
            draggable: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleClose() {
    setedit(false);
    setAccess(false);
    Refresh();
    setallocationopen(false);
    dispatch(PROJECTCREATE(false));
    setReport(false);
    setseamlessopen(false);
    setModules([
      {
        Name: "",
        Type: "Monolith",
        FullName: "",
      },
    ]);
    // setRefresh(true);
  }

  const handleSecondFriend = (rowDataProjectId) => {
    // setProjectdetails(
    //   projectdetails.map((friend) =>
    //     // Here you accept a id argument to the function and replace it with hard coded 🤪 2, to make it dynamic.
    //     friend.ProjectId === rowDataProjectId
    //       ? { ...friend, selectOption: !friend.selectOption }
    //       : { ...friend }
    //   )
    // );
    dispatch(
      HANDLE_ON_CHANGE({
        name: "projectdetails",
        value: projectdetails.map((friend) =>
          // Here you accept a id argument to the function and replace it with hard coded 🤪 2, to make it dynamic.
          friend.ProjectId === rowDataProjectId
            ? { ...friend, selectOption: !friend.selectOption }
            : { ...friend }
        ),
      })
    );
    setSelectedId(selectedId == rowDataProjectId ? "" : rowDataProjectId);
  };
  const handleStatusUpdate = async (id, newStatus) => {
    try {
      const response = await axios.patch(
        `agilesaas_project_master?ClientId=eq.${clientd}&ProjectId=eq.${id}`,
        { Status: newStatus }
      );

      console.log("Status updated successfully:", response.data);

      toast.success(`Project status successfully updated to "${newStatus}"!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      Refresh();
    } catch (error) {
      console.error("Error updating status:", error);

      toast.error("Failed to update status. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const handledelteUpdate = async (id, newStatus) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this project?"
    );

    if (!confirmation) {
      return;
    }
    let patchproject = {
      IsActive: "N",
      Status: newStatus,
    };
    try {
      const response = await axios.patch(
        `agilesaas_project_master?ClientId=eq.${clientd}&ProjectId=eq.${id}`,
        patchproject
      );

      console.log("Status updated successfully:", response.data);

      const deleteData = {
        IsCurrent: "N",
        AllocPercentage: 0,
        ProjectStartDate: moment().format("YYYY-MM-DD"),
        ProjectEndDate: moment().format("YYYY-MM-DD"),
      };

      await axios.patch(
        `agilesaas_project_mapping?ProjectCode=eq.${id}&ClientId=eq.${clientd}`,
        deleteData
      );

      const patchIssue = {
        AssignedTo: null,
        AssignedToDetails: { FN: null, LN: null },
        AssignedDate: moment().format("YYYY-MM-DD"),
      };

      await axios.patch(
        `agilesaas_issue_details?ProjectId=eq.${id}&ClientId=eq.${clientd}&CurrentStage->0->>StageName=in.(Refined,Backlog,In Development)`,
        patchIssue
      );

      toast.success(`Deleted Successfully!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      Refresh();
    } catch (error) {
      console.error("Error updating status:", error);

      toast.error("Failed to update status. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  function selectcustom(rowData) {
    return (
      <>
        <div onClick={() => handleSecondFriend(rowData.id)}>
          <div
            style={{
              padding: "5px 5px 10px 15px",
              width: "40px",
              cursor: "pointer",
            }}
          >
            <MoreVertIcon
              style={{
                color: "#198ae3",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            />
          </div>
          {selectedId == rowData.id && (
            <div
              style={{
                backgroundColor: "#ffffff",
                position: "relative",
                width: "150px",
                marginRight: "240px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                overflow: "hidden",
                zIndex: 10,
                border: "1px solid #ddd",
              }}
            >
              <ul
                style={{
                  margin: 0,
                  padding: "5px 0",
                  listStyleType: "none",
                }}
              >
                <MenuItem
                  icon={<EditIcon style={{ fontSize: "16px" }} />}
                  label="Edit"
                  onClick={() => handleEditing(rowData)}
                />
                <MenuItem
                  icon={<AssessmentIcon style={{ fontSize: "16px" }} />}
                  label="Report"
                  onClick={() => handleReport(rowData, "Report")}
                />

                {rowData?.Status != "Hold" && (
                  <>
                    <MenuItem
                      icon={
                        <PowerSettingsNewIcon style={{ fontSize: "16px" }} />
                      }
                      label="On-Hold"
                      onClick={() => handleStatusUpdate(rowData.id, "Hold")}
                    />
                  </>
                )}
                {rowData?.Status === "In Progress" && (
                  <>
                    <MenuItem
                      icon={<DoneAllIcon style={{ fontSize: "16px" }} />}
                      label="Mark as Completed"
                      onClick={() =>
                        handleStatusUpdate(rowData.id, "Completed")
                      }
                    />
                  </>
                )}

                {rowData?.Status === "Hold" && (
                  <MenuItem
                    icon={<PlayArrowIcon style={{ fontSize: "16px" }} />}
                    label="Resume"
                    onClick={() =>
                      handleStatusUpdate(rowData.id, "In Progress")
                    }
                  />
                )}

                {/* {rowData?.Status === "Completed" && ( */}
                <MenuItem
                  icon={<Delete style={{ fontSize: "16px", color: "red" }} />}
                  label="Delete / Close"
                  onClick={() => handledelteUpdate(rowData.id, "Deleted")}
                />
                {/* )} */}

                <MenuItem
                  icon={
                    rowData?.IsDefault === "Y" ? (
                      <CheckCircleIcon
                        style={{ color: "#66CDAA", fontSize: "16px" }}
                      />
                    ) : (
                      <CheckCircleOutlineIcon style={{ fontSize: "16px" }} />
                    )
                  }
                  label={
                    rowData?.IsDefault === "Y"
                      ? "Default Project"
                      : "Set as default"
                  }
                  onClick={
                    rowData?.IsDefault === "Y"
                      ? null
                      : () => handleDefaultProject(rowData?.ProjectIdNew)
                  }
                />
              </ul>
            </div>
          )}
        </div>
      </>
    );
  }

  const MenuItem = ({ icon, label, onClick }) => (
    <li
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "6px 8px", // Slightly reduced padding
        cursor: "pointer",
        transition: "background 0.3s",
        fontSize: "12px", // Consistent font size
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7ff")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      {icon}
      <span style={{ marginLeft: "5px" }}>{label}</span>
    </li>
  );

  // function SelectDefault(rowData) {
  //   return (
  //     <div>
  //       <Tag color="green">Default Project</Tag>
  //     </div>
  //   );
  // }
  const theme = createTheme({
    palette: {
      grey: {
        200: "#your-light-grey-color",
        800: "#your-dark-grey-color",
      },
      // Other palette colors...
    },
    // Other theme settings...
  });

  const BorderLinearProgress = styled(LinearProgress)(({ theme, value }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? `#1a90ff` : `#308fe8`,
    },
  }));

  function projectcrt() {
    dispatch(PROJECTCREATE(true));
    setProjectName("");
  }

  const Columns = [
    // {
    //   title: "Project Id",
    //   field: "ProjectId",
    //   cellStyle: { textAlign: "left" }
    // },
    {
      title: "Project Id",
      field: "ProjectId",
      cellStyle: { textAlign: "left" },
      render: (rowData) => (
        <div>
          <span>{rowData?.ProjectId}</span>
          {rowData?.IsDefault === "Y" && (
            <div className="d-flex mt-2">
              <Tag color="green" style={{ fontSize: "10px" }}>
                Selected as default project
              </Tag>
            </div>
          )}
        </div>
      ),
    },

    { title: "Projects Name", field: "projectname" },
    { title: "Modules", field: "modules" },
    { title: "Created By", field: "createdby" },

    {
      title: "Progress",
      field: "Progress",
      render: (rowData) => {
        const projectData = overallCount?.filter(
          (e) => e.ProjectId == rowData.id
        );
        const totaltickets = projectData
          ?.flatMap((e) => e.CurrentStage)
          ?.filter(
            (e) =>
              e.StageCode === "BLG" ||
              e.StageCode === "DEV" ||
              e.StageCode === "DONE"
          )?.length;

        const completedticets = projectData
          ?.flatMap((e) => e.CurrentStage)
          ?.filter((e) => e.StageCode === "DONE")?.length;

        const progresspercentage =
          completedticets > 0 ? (completedticets / totaltickets) * 100 : 0;

        return (
          <ThemeProvider theme={theme} value={progresspercentage}>
            <BorderLinearProgress
              value={progresspercentage}
              variant="determinate"
            />
          </ThemeProvider>
        );
      },
    },
    { title: "Start / End Date", field: "startdate" },
    // { title: "End Date", field: "enddate" },
    {
      title: "Status",
      field: "Status",
      render: (rowData) => {
        let statusColor;
        let displayStatus;
        let animateStyle = {}; // Inline styles for animation

        switch (rowData.Status) {
          case "In Progress":
            statusColor = "#198ae3"; // Blue
            displayStatus = "In Progress";
            animateStyle = {
              display: "inline-block",
              animation: "shine 1.5s infinite ease-in-out", // Keyframes for shining effect
            };
            break;
          case "Hold":
            statusColor = "#ff9800"; // Orange
            displayStatus = "On Hold";
            break;
          case "Deleted":
            statusColor = "#f44336"; // Red
            displayStatus = "Deleted";
            break;
          case "Completed":
            statusColor = "#4caf50"; // Green
            displayStatus = "Completed";
            break;
          case null: // Status is null or undefined
          default:
            statusColor = "#9e9e9e"; // Gray
            displayStatus = "Not Yet Started";
        }

        // Define keyframes inline for shining effect
        const keyframes = `
          @keyframes shine {
            0% { opacity: 0.8; filter: brightness(1); }
            50% { opacity: 1; filter: brightness(1.5); }
            100% { opacity: 0.8; filter: brightness(1); }
          }
        `;

        // Inject keyframes into the document head
        if (!document.getElementById("shine-animation")) {
          const style = document.createElement("style");
          style.id = "shine-animation";
          style.innerHTML = keyframes;
          document.head.appendChild(style);
        }

        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                display: "inline-block",
                color: statusColor,
                fontSize: "medium",
                marginRight: 5,
                ...animateStyle, // Apply animation style dynamically
              }}
            >
              <FlagIcon style={{ color: statusColor, fontSize: "24px" }} />
            </span>
            <span style={{ color: statusColor }}>{displayStatus}</span>
          </div>
        );
      },
    },

    {
      title: "Action",
      field: "Action",
      render: (rowData) => <>{selectcustom(rowData)}</>,
    },
    // {
    //   title: "",
    //   field: "Default",
    //   render: (rowData) => <>{SelectDefault(rowData)}</>,
    // },
  ];

  const handleSelectProject = (e) => {
    const newDate = new Date();
    setModules(
      e?.data?.ProjectModules
        ? e?.data?.ProjectModules
        : [
            {
              Name:
                e?.data &&
                e?.data?.ProjectName?.replace(/\s+/g, "")?.replace(
                  /[^a-zA-Z0-9]/g,
                  ""
                ),
              Type: "Monolith",
              FullName: "",
            },
          ]
    );
    handleDateChange(e?.data ? new Date(e?.data?.StartDate) : new Date());
    handleDateChange2(
      e?.data
        ? new Date(e?.data?.EndDate)
        : newDate.setMonth(newDate.getMonth() + 6)
    );
    setSelectedProject(e);
    setProjectName(e?.data?.ProjectName ? e?.data?.ProjectName : "");
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#FFF",
      border: state.isFocused
        ? "2px solid rgb(82, 80, 223)"
        : "1px solid rgba(0, 0, 0, 0.10)",
      borderRadius: 8,
      // width: '110%',
      // marginLeft: elementWidth > 1300 ? -35 : -20,

      height: 38,
      // background: "#f3f3ff",
      // match with the menu
      // borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      // borderColor: state.isFocused ? "yellow" : "green",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        // borderColor: state.isFocused ? "red" : "blue"
      },
    }),
    menu: (base) => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      // marginTop: 0,
      // marginLeft: elementWidth > 1300 ? -35 : -20,
      width: `${Math.max(
        ...poptions.map((option) => option.label.length * 10)
      )}px`, // Adjust the multiplier based on your content
      minWidth: "100%",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };
  const checkname = KanbanBoardData?.filter(
    (x) => x.ProjectId == selectedProject?.value
  )?.length;
  // console.log(checkname);

  const allocateproject = (
    <Button
      variant="outline-success"
      size="sm"
      disabled={projectdetails?.length == 0 || projectRole == "TL"}
      className="action-icon fontdesign ml-3"
      style={{ fontWeight: "normal", borderRadius: "8px" }}
      onClick={() => {
        setProAllocateModal(true);
      }}
    >
      <GroupAddIcon fontSize="small" /> Allocate
    </Button>
  );
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const TabPanel = ({ children, value, index }) => {
    return (
      <div role="tabpanel" hidden={value !== index} style={{ padding: "16px 0" }}>
        {value === index && <>{children}</>}
      </div>
    );
  };
  
  const classes = useStyles();
  const open = Boolean(anchorEl);
  return (
    <>
      {isLoading ? (
        <div
          className=" d-flex align-items-center"
          style={{ justifyContent: "center", height: 460 }}
        >
          <span
            className="spinner-border"
            role="status"
            aria-hidden="true"
            style={{ color: "rgb(82, 80, 229)" }}
          ></span>
        </div>
      ) : (
        <div style={{ backgroundColor: "#f<6f7fa" }}>
          {prjallocation == true ? null : (
            <>
              <label className="ProjectlabelStyle1 ml-4">Projects</label>
              <Row className="ButtonGrp1 mt-2 ml-2">
                <Col style={{ display: "flex", justifyContent: "start" }}>
                  {
                    <Tooltip
                      title={
                        projectdetails?.length == 0
                          ? "Create project"
                          : projectRole == "TL"
                          ? "TL dosen't have the access to create Project."
                          : ""
                      }
                      placement="top"
                    >
                      <Button
                        variant="outline-danger"
                        size="sm"
                        fontSize="small"
                        className="action-icon fontdesign"
                        disabled={projectRole == "TL"}
                        style={{ fontWeight: "normal", borderRadius: "8px" }}
                        onClick={() => projectcrt()}
                      >
                        <AddCircleRoundedIcon fontSize="small" /> Create
                      </Button>
                    </Tooltip>
                  }{" "}
                  {createdby?.[0]?.IsOrgAdmin == "Y" ? (
                    <Button
                      variant="outline-success"
                      size="sm"
                      className="action-icon fontdesign ml-3"
                      style={{ fontWeight: "normal", borderRadius: "8px" }}
                      onClick={() => setinviteuser(true)}
                    >
                      <GroupAddIcon fontSize="small" /> Invite user
                    </Button>
                  ) : (
                    ""
                  )}{" "}
                  <Tooltip
                    title={
                      projectdetails?.length == 0
                        ? "Please create project to allocate"
                        : projectRole == "TL"
                        ? "TL dosen't have the access to Allocate Project  "
                        : ""
                    }
                    placement="top"
                  >
                    {allocateproject}
                  </Tooltip>{" "}
                  {createdby?.[0]?.IsOrgAdmin == "Y" ? (
                    <Button
                      variant="outline-success"
                      size="sm"
                      className="action-icon fontdesign ml-3"
                      style={{ fontWeight: "normal", borderRadius: "8px" }}
                      onClick={() => setmanageaccess(true)}
                    >
                      <SwitchAccessShortcutAddIcon fontSize="small" /> Manage
                      Access
                    </Button>
                  ) : (
                    ""
                  )}{" "}
                </Col>
              </Row>
            </>
          )}
          <br></br>
          {prjallocation == true ? null : (
            <Row style={{ marginRight: "1%" }} className="ml-1">
              <Col lg={3} md={6} sm={12}>
                <Card className="ProgressCard" style={{ boxShadow: 0 }}>
                  <Row
                    style={{
                      height: "100%",
                      justifySelf: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="Col1"
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <span
                        className="Iconback ml-5"
                        style={{ backgroundColor: "#dcdefc" }}
                      >
                        <NoteAltOutlinedIcon
                          className="cardIcon"
                          fontSize="medium"
                        />
                      </span>
                    </div>
                    <div className="Col2 ml-3">
                      <label className="labelStyle">Projects</label>
                      <label className="labelStyleV">
                        {projectdetails.length}
                      </label>
                    </div>
                    {/* <div className="Col3">
                <MoreVertIcon
                  style={{ marginLeft: "-100%", color: "#6c757d" }}
                />
              </div> */}
                  </Row>
                </Card>
              </Col>
              <Col lg={3} md={6} sm={12}>
                <Card className="ProgressCard" style={{ boxShadow: 0 }}>
                  <Row
                    style={{
                      height: "100%",
                      justifySelf: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="Col1"
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <span
                        className="Iconback ml-5"
                        style={{ backgroundColor: "#c2f3e5" }}
                      >
                        <GroupsIcon
                          className="cardIcon"
                          fontSize="medium"
                          style={{ color: "#45d097" }}
                        />
                      </span>
                    </div>
                    <div className="Col2 ml-3">
                      <label className="labelStyle">Task</label>
                      <label className="labelStyleV">
                        {/* {projectdetails.length == 0 ? 0 : 0} */}
                        {taskCount}
                      </label>
                    </div>
                    {/* <div className="Col3">
                <MoreVertIcon
                  style={{ marginLeft: "-100%", color: "#6c757d" }}
                />
              </div> */}
                  </Row>
                </Card>
              </Col>
              <Col lg={3} md={6} sm={12}>
                <Card className="ProgressCard" style={{ boxShadow: 0 }}>
                  <Row
                    style={{
                      height: "100%",
                      justifySelf: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="Col1"
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <span
                        className="Iconback ml-5 "
                        style={{ backgroundColor: "#cdebf3" }}
                      >
                        <PersonAddIcon
                          className="cardIcon"
                          fontSize="medium"
                          style={{ color: "#39afd1" }}
                        />
                      </span>
                    </div>
                    <div className="Col2 ml-3">
                      <label className="labelStyle">Developer</label>
                      <label className="labelStyleV">
                        {
                          employee?.filter(
                            (e) =>
                              e.RoleDetails.RoleCode != "SM" &&
                              e.RoleDetails.RoleCode != "KA"
                          ).length
                        }
                      </label>
                    </div>
                    {/* <div className="Col3">
                <MoreVertIcon
                  style={{ marginLeft: "-100%", color: "#6c757d" }}
                />
              </div> */}
                  </Row>
                </Card>
              </Col>
              <Col lg={3} md={6} sm={12}>
                <Card className="ProgressCard" style={{ boxShadow: 0 }}>
                  <Row
                    style={{
                      height: "100%",
                      justifySelf: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="Col1"
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <span
                        className="Iconback ml-5"
                        style={{ backgroundColor: "#fff0d6" }}
                      >
                        <CreateNewFolderIcon
                          className="cardIcon"
                          fontSize="medium"
                          style={{ color: "#ffc35a" }}
                        />
                      </span>
                    </div>
                    <div className="Col2 ml-3">
                      <label className="labelStyle">Development</label>
                      <label className="labelStyleV">{developmentCount}</label>
                    </div>
                    {/* <div className="Col3">
                <MoreVertIcon
                  style={{ marginLeft: "-30%", color: "#6c757d" }}
                />
              </div> */}
                  </Row>
                </Card>
              </Col>
            </Row>
          )}
          {/* <br></br>
      <Card className="project">
        <div 
          className="header_style text-secondary"
          style={{
            fontWeight: "bold",
            textAlign: "center",
            fontSize: "20px",
            marginTop: "50px",
            marginLeft: "30px",
            marginBottom: "20px",
          }}
        >
          Add Project
        </div>
       
        <Table responsive striped bordered hover className="position-relative">
          <thead id="report">
            <tr>
              <th className="text">Project Name</th>
              <th className="text">Start Date</th>
              <th className="text">End Date</th>
            </tr>
          </thead>

          <tr>
            <td>
              <TextField
                variant="outlined"
                className="mytextteam"
                size="small"
                value={projectnames}
                onChange={(e) => handleprojectname(e)}
                type="text"
                error={error}
                autoComplete="off"
                required
                helperText={error}
                // disabled
              />
            </td>

            <td>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  // varient="dialog"
                  // format="dd/MM/yyyy"
                  // margin="normal"
                  name="project start date"
                  value={selectedDate}
                  onChange={(date) => handleDateChange(date)}
                  format="dd-MM-yyyy"
                  views={["year", "month", "date"]}
                  className=""
                  style={{ width: "170px" }}
                  autoComplete="off"
                  // shouldDisableDate={disableWeekends}
                  disablePast
                  error={dateerror}
                  helperText={dateerror}
                  required
                />
              </MuiPickersUtilsProvider>
            </td>

            <td>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  varient="dialog"
                  // format="dd/MM/yyyy"
                  margin="normal"
                  name="project start date"
                  value={selectedDate2}
                  onChange={(date) => handleDateChange2(date)}
                  format="dd-MM-yyyy"
                  views={["year", "month", "date"]}
                  className=""
                  style={{ width: "170px" }}
                  autoComplete="off"
                  // shouldDisableDate={disableWeekends}
                  disablePast
                  required
                />
              </MuiPickersUtilsProvider>
            </td>
          </tr>
        </Table>
       
       <div>
          <Button
            className="Card_Button_Color_Approve btn-greeng  justify-content-center mr-2"
            onClick={submit}
            style={{ marginLeft: "360px", position: "relative" }}
          >
            Create
          </Button>

          <Button
            className="Card_Button_Color_Approve btn-greeng ml-1"
            onClick={handleallocation}
            // style={{position:"relative"}}
          >
            Allocate project
          </Button>
          </div>
        <br></br>
      </Card> */}
          <br></br>
          {prjallocation == true ? null : (
            <div className="tableback">
              <div className="tabel1">
                <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/icon?family=Material+Icons"
                ></link>
                <MaterialTable
                  title={"Project Details"}
                  columns={Columns.map((e) => e)}
                  components={{
                    Pagination: PatchedPagination,
                  }}
                  data={projectdetails?.map((e) => {
                    // console.log(e, "project data");
                    return {
                      ...e,
                      projectname: e?.ProjectName,
                      createdby: `${e.CreatedByDetails.Name} ( #${e?.CreatedBy} )`,
                      modules: (
                        <div>
                          {e?.ProjectModules
                            ? e?.ProjectModules?.map((x) => (
                                <label>{x?.FullName}</label>
                              ))
                            : "-"}
                        </div>
                      ),
                      startdate: (
                        <div>
                          <label>{`${moment(e?.StartDate).format(
                            dateformat
                          )} - ${moment(e?.EndDate).format(
                            dateformat
                          )}`}</label>
                          <label style={{ textAlign: "center" }}>{`( ${moment(
                            e?.EndDate
                          ).diff(moment(e?.StartDate), "day")} days)`}</label>
                        </div>
                      ),
                      // enddate: moment(e?.EndDate).format("DD MMM YYYY"),
                      ProjectId: `${e?.ProjectShortCode} ( #${e?.ProjectId} )`,
                      id: e?.ProjectId,
                      Progress: 20,
                      Status: e?.Status,
                      Action: "",
                      ProjectIdNew: e?.ProjectId,
                    };
                  })}
                  options={{
                    actionsColumnIndex: -1,
                    exportAllData: true,
                    exportButton: true,
                    columnResizable: true,
                    filtering: false,
                    sorting: true,
                    paging: true,
                    pageSize: 10,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [10, 20, 30, 40],

                    headerStyle: {
                      whiteSpace: "nowrap",
                      fontWeight: "700",
                      fontSize: "medium",
                      // backgroundColor: "#eef2f7",
                      color: "black",
                      padding: "12px ",
                      textAlign: "left",
                      zIndex: "1",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: "medium",
                      padding: "21px",
                      color: "#6c757d",
                      // padding: "15px 2px",
                    },
                    rowStyle: (rowdata) => {
                      if (rowdata.tableData.id % 2 != 0) {
                        // return { backgroundColor: "#f6f7fb" };
                      }
                    },
                  }}
                  onRowClick={(evt, selectedRow) => {
                    setSelectedRow(selectedRow.tableData.id);
                    // setSelectedId('')
                  }}
                  // actions={[
                  //   (rowData) => ({
                  //     icon: "edit",
                  //     tooltip: "edit",
                  //     onClick: (event, rowData) => handleEditing(rowData),
                  //   }),
                  //   (rowData) => ({
                  //     icon: "assignment",
                  //     tooltip: "Report",
                  //     onClick: (event, rowData) => handleReport(rowData, "Report"),
                  //   }),
                  // (rowData) => ({
                  //   icon: "delete",
                  //   tooltip: "Deleting",
                  //   onClick: (event, rowdata) => remove(rowdata, "Delete"),
                  // }),
                  // ]}
                />
              </div>
            </div>
          )}
          {/* <Dialog
        open={editopen}
        onClose={() => {
          handleClose();
        }}
        className="mainbox"
        // maxWidth="1500px"
        maxWidth="lg"
        fullWidth={true}

        // fullScreen={true}
      >
        <DialogTitle>
          <Row
            className=""
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Col lg={10} md={10}>
              <label
                className="headerdialog text-secondary"
                style={{ fontWeight: "bold" }}
              >
                Edit Project
              </label>
            </Col>
            <IconButton
              className="d-flex justify-content-end"
              onClick={() => {
                handleClose(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Row>
        </DialogTitle>

        <DialogContent>
          <Editproject
            rowData={row}
            row={row}
            projectdetails={projectdetails}
            setProjectdetails={setProjectdetails}
            close = {handleClose}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog> */}
          <Dialog
            open={editopen}
            onClose={() => handleClose(false)}
            maxWidth="sm"
            fullWidth={true}

            // fullScreen={true}
          >
            <DialogTitle>
              <Row
                className="mainbox"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={10} md={10}>
                  <label style={{ color: "#2593B8", fontWeight: "bold" }}>
                    Edit project and module
                  </label>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => {
                    handleClose(false);
                    setSelectedId("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Editproject
                rowData={row}
                row={row}
                // projectdetails={projectdetails}
                // setProjectdetails={setProjectdetails}
                close={handleClose}
                setedit={setedit}
                modules={modules}
                setModules={setModules}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          <Dialog
            open={Report}
            onClose={() => {
              handleClose();
            }}
            className="mainbox"
            // maxWidth="1500px"
            maxWidth="lg"
            fullWidth={true}

            // fullScreen={true}
          >
            <DialogTitle>
              <Row
                className="mainbox"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={10} md={10}>
                  <label style={{ color: "#2593B8", fontWeight: "bold" }}>
                    {row?.ProjectName}
                  </label>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => {
                    handleClose(false);
                    setSelectedId("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>
            <DialogContent>
              <Reportallocation
                rowData={row}
                row={row}
                // projectdetails={projectdetails}
                // setProjectdetails={setProjectdetails}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          <Dialog
            open={Access}
            onClose={() => {
              handleClose();
            }}
            className="mainbox"
            maxWidth="lg"
            fullWidth={true}
          >
            <DialogTitle>
              <Row
                className="mainbox"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={10} md={10}>
                  <label style={{ color: "#2593B8", fontWeight: "bold" }}>
                    {row?.ProjectName} (Granting access to the Scrum Master)
                  </label>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => {
                    handleClose(false);
                    setSelectedId("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>
            <DialogContent>
              {/* Your Team Member and Project Name Rows */}
              <Row className="mb-4 mt-2">
                <Col lg={6}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label className="SprintlabelStyle">
                      Team Member
                      <label className="createAlert">*</label>
                    </label>
                    <span className=" ml-1" style={{ paddingBottom: "12px" }}>
                      <i
                        style={{ cursor: "pointer" }}
                        className="fa fa-info-circle text-muted"
                        aria-label="info"
                        aria-owns={open ? "mouse-over-popover" : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}
                      ></i>
                      <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        classes={{
                          paper: classes.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                      >
                        <Typography style={{ fontSize: "11px" }}>
                          Click on team member to add multiple team members
                        </Typography>
                      </Popover>
                    </span>
                  </div>

                  <Select
                    style={{ width: "170px" }}
                    maxMenuHeight={180}
                    name="TeamMemberId"
                    isMulti={true}
                    // isDisabled={edit}
                    options={employeeOption}
                    // onChange={(e) => handleInputChange(e, "TeamMemberId")}
                    // error={Errors.TeamMemberId}
                    // helperText={Errors.TeamMemberId}
                    // value={
                    //   Values.TeamMemberId
                    //     ? employeeOption?.filter((e) =>
                    //         Values?.TeamMemberId?.includes(e.value)
                    //       )
                    //     : []
                    // }
                    required
                    native
                  />
                  {/* <FormHelperText style={{ color: "red" }}> */}
                  {/* {Errors.TeamMemberId} */}
                  {/* </FormHelperText> */}
                </Col>
                <Col lg={6}>
                  <label className="SprintlabelStyle">
                    From
                    <label className="createAlert">*</label>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      style={{ width: "100%" }}
                      // disablePast={!edit}
                      varient="dialog"
                      format="dd/MM/yyyy"
                      // margin="normal"
                      views={["year", "month", "date"]}
                      // label="Allocation Start Date"
                      // className="select MuiFormControl-marginNormal"
                      // value={Values.ProjectStartDate}
                      // error={Errors.ProjectStartDate}
                      // onChange={(date) =>
                      //   DateInputChange(convertToPara("ProjectStartDate", date))
                      // }
                    />
                  </MuiPickersUtilsProvider>
                </Col>
              </Row>
              <Row className="mb-4 mt-2">
                <Col lg={6}>
                  <label className="SprintlabelStyle">
                    To
                    <label className="createAlert">*</label>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      style={{ width: "100%" }}
                      // disablePast={!edit}
                      varient="dialog"
                      format="dd/MM/yyyy"
                      // margin="normal"
                      views={["year", "month", "date"]}
                      // label="Allocation Start Date"
                      // className="select MuiFormControl-marginNormal"
                      // value={Values.ProjectStartDate}
                      // error={Errors.ProjectStartDate}
                      // onChange={(date) =>
                      //   DateInputChange(convertToPara("ProjectStartDate", date))
                      // }
                    />
                  </MuiPickersUtilsProvider>
                </Col>
              </Row>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => handleClose()}
                style={{
                  fontSize: 14,
                  padding: 9,
                  width: 100,
                  height: 40,
                  borderRadius: 8,
                  marginRight: 14,
                  border: "2px solid #5250E5",
                  backgroundColor: "#fff",
                  color: "#5250E5",
                  textAlign: "center",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                // onClick={(e) => {
                //   addAllocationHandler(e);
                // }}
                disabled={checkSubmit}
                style={{
                  fontSize: 14,
                  padding: 9,
                  width: 100,
                  height: 40,
                  borderRadius: 8,
                  backgroundColor: "#5250E5",
                  color: "#fff",
                  // border: "0px solid #5A88F1",
                  textAlign: "center",
                  textTransform: "none",
                }}
              >
                {checkSubmit ? (
                  <span
                    className="spinner-border"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "#fff", width: "1.5rem", height: "1.5rem" }}
                  ></span>
                ) : (
                  "Submit"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={allocationopen}
            onClose={() => {
              handleClose();
            }}
            className="mainbox"
            // maxWidth="800px"
            maxWidth="lg"
            // fullWidth={true}

            // fullScreen={true}
          >
            <DialogTitle>
              <Row
                className=""
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={0} md={8}>
                  <label
                    className="headerallocate text-secondary"
                    style={{ fontWeight: "bold" }}
                  >
                    Project Allocation
                  </label>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>

            <DialogContent>
              <ProjectAllocation
                projectdetails={projectdetails}
                employee={employee}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          <Dialog
            open={seamlessopen}
            // open={true}
            onClose={() => {
              handleClose();
            }}
            className="mainbox"
            // maxWidth="1500px"
            // maxWidth="1500px"
            maxWidth="lg"
          >
            <DialogTitle>
              <Row
                className=""
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={10} md={10}>
                  <label
                    className="headerdialog "
                    style={{ fontWeight: "bold", color: "rgb(37, 147, 184)" }}
                  >
                    Allocate Project -{" "}
                    <span className="text-danger">{projectnames}</span>
                  </label>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => {
                    handleClose(false);
                    setProjectName("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>

            <DialogContent>
              <Allocationseamless
                // projectdetails={projectdetails}
                // setProjectdetails={setProjectdetails}
                Refresh={Refresh}
                Projectname={projectnames}
                setseamlessopen={setseamlessopen}
                seamlessopen={seamlessopen}
                employeeDetails={employee}
                setProjectName={setProjectName}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          <Dialog
            open={openProCreate}
            onClose={() => ProjectClose()}
          
            className="mainbox"
            maxWidth="md"
            fullWidth={true}
            PaperProps={{ style: { overflowY: "visible" } }}
            // style={{ overflowY: 'hidden' }}
          >
            {
              // module ?
              //   <DialogTitle className="title">
              //     <Row
              //       className="mainbox"
              //       style={{ display: "flex", justifyContent: "space-between" }}
              //     >
              //       <Col lg={10} md={10}>
              //         <label style={{ color: "#2593B8", fontWeight: "bold" }}>Create New Module</label>
              //       </Col>
              //       <IconButton
              //         className="d-flex justify-content-end"
              //         onClick={() => handlemoduleClose()}
              //       >
              //         <CloseIcon />
              //       </IconButton>
              //     </Row>
              //   </DialogTitle>
              //   :
              projectslength <= check ? (
                ""
              ) : (
                <DialogTitle>
                  <Row
                    className="mainbox"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Col lg={10} md={10}>
                      <label style={{ color: "#2593B8", fontWeight: "bold" }}>
                      Create and manage projects
                      </label>
                    </Col>
                    <IconButton
                      className="d-flex justify-content-end"
                      onClick={() => ProjectClose()}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Row>
                </DialogTitle>
              )
            }
            <Divider />
            {projectslength <= check ? (
              <DialogContent style={{ padding: "5%" }}>
                {/* You have exceeded the minimal plan please upgrade to higher plan Further to create a project */}
                You have exceeded the limit as per your plan. Extend your plan
                using Administration portal.
              </DialogContent>
            ) : (
              <DialogContent>
                <Row className={error.projectnames ? "mb-0" : "mb-3"}>
                  {poptions?.length > 0 && (
                    <Col>
                      <label className="SprintlabelStyle">
                        Select Project
                        <label className="createAlert">*</label>
                      </label>
                      <Select
                        options={poptions}
                        value={poptions.filter(
                          (option) => option?.value === selectedProject?.value
                        )}
                        onChange={(e) => handleSelectProject(e)}
                        style={customStyles}
                      />
                      {/* {console.log(error)} */}
                    </Col>
                  )}
                  {/* {
                        selectedProject?.value == "new" && */}
                  <Col>
                    <label className="SprintlabelStyle">
                      Project Name
                      <label className="createAlert">*</label>
                    </label>
                    <Input
                      placeholder="Enter Title"
                      variant="outlined"
                      className="inpui SprintFormFields"
                      size="small"
                      style={{ borderRadius: 14 }}
                      value={projectnames}
                      onChange={(e) => handleprojectname(e)}
                      type="text"
                      invalid={error.projectnames !== undefined}
                      disabled={checkname > 0}
                    />
                    {/* {console.log(error)} */}
                  </Col>
                  {/* } */}
                </Row>
                {error.projectnames && (
                  <div
                    className={error.projectnames ? "mb-3" : "mb-0"}
                    style={{ fontSize: 14, color: "red" }}
                  >
                    {error.projectnames}
                  </div>
                )}
                {/* <ProjectModules
                  modules={modules}
                  setModules={setModules}
                  projectname={projectnames}
                  projectid={selectedProject?.value}
                /> */}
             
                
                <Row className="mb-3">
                  <Col>
                    <label className="SprintlabelStyle">
                      Start Date
                      {/* <label className="createAlert">*</label> */}
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        varient="dialog"
                        // format="dd/MM/yyyy"
                        margin="groove"
                        name="project start date"
                        value={selectedDate}
                        onChange={(date) => handleDateChange(date)}
                        format="dd-MM-yyyy"
                        views={["year", "month", "date"]}
                        className=""
                        style={{ width: "100%" }}
                        autoComplete="off"
                        // shouldDisableDate={disableWeekends}
                        disablePast
                        invalid={error.selectedDate !== undefined}
                        error={dateerror}
                        helperText={dateerror}
                        // required
                      />
                    </MuiPickersUtilsProvider>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <label className="SprintlabelStyle">
                      End Date
                      {/* <label className="createAlert">*</label> */}
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        varient="dialog"
                        // format="dd/MM/yyyy"
                        margin="inline"
                        name="project start date"
                        value={selectedDate2}
                        onChange={(date) => handleDateChange2(date)}
                        format="dd-MM-yyyy"
                        views={["year", "month", "date"]}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        // shouldDisableDate={disableWeekends}
                        disablePast
                        // required
                      />
                    </MuiPickersUtilsProvider>
                  </Col>
                </Row>
                <Tabs
      value={activeTab}
      onChange={(event, newValue) => setActiveTab(newValue)}
      indicatorColor="primary"
      textColor="primary"
      variant="fullWidth"
    >
      <Tab label="Modules" />
      <Tab label="Project Allocation" disabled={projectDetails?.length == 0}/>
      <Tab label="Manage Access" disabled={projectDetails?.length == 0}/>
    </Tabs>

    <TabPanel value={activeTab} index={0}>
      {/* Modules Tab Content */}
      <ProjectModules
        modules={modules}
        setModules={setModules}
        projectname={projectnames}
        projectid={selectedProject?.value}

      />
    </TabPanel>

    <TabPanel value={activeTab} index={1}>
      {/* Project Allocation Tab Content */}
      <ProjectInAllocation
        projectdetails={projectdetails}
        handleClose={AllocateClose}
        employee={employee}
        ProAllocateModal={ProAllocateModal}
        selectedproject={selectedProject?.value}
      />
    </TabPanel>

    <TabPanel value={activeTab} index={2}>
      {/* Manage Access Tab Content */}
      <ProjectManageAccess
        projectdetails={projectdetails}
        handleClose={AllocateClose}
        employee={employee}
        ProAllocateModal={ProAllocateModal}
        setmanageaccess={setmanageaccess}
        manageaccess={manageaccess}
        selectedproject={selectedProject?.value}
      />
    </TabPanel>
              </DialogContent>
            )}
            <DialogActions>
            {activeTab == 0 ? (
  projectslength <= check ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "right",
      }}
    >
      <Button1
        onClick={() => ProjectClose()}
        style={{
          fontSize: 14,
          padding: 9,
          width: 100,
          height: 40,
          borderRadius: 8,
          backgroundColor: "#5250E5",
          color: "#fff",
          border: "0px solid #5A88F1",
          textAlign: "center",
          textTransform: "none",
        }}
      >
        Ok
      </Button1>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "right",
      }}
    >
      <Button1
        onClick={() => ProjectClose()}
        style={{
          fontSize: 14,
          padding: 9,
          width: 120,
          height: 40,
          borderRadius: 8,
          marginRight: 14,
          border: "2px solid #5250E5",
          backgroundColor: "#fff",
          color: "#5250E5",
          textAlign: "center",
          textTransform: "none",
        }}
      >
        Cancel
      </Button1>
      <Button1
        type="submit"
        onClick={(e) => submit(e)}
        disabled={checkSubmit}
        style={{
          fontSize: 14,
          padding: 9,
          width: 170,
          height: 40,
          borderRadius: 8,
          backgroundColor: "#5250E5",
          color: "#fff",
          border: "0px solid #5A88F1",
          textAlign: "center",
          textTransform: "none",
        }}
      >
        {checkSubmit ? (
          <span
            className="spinner-border"
            role="status"
            aria-hidden="true"
            style={{
              color: "#fff",
              width: "1.5rem",
              height: "1.5rem",
            }}
          ></span>
        ) : (
          "Create/Update Project"
        )}
      </Button1>
    </div>
  )
) : null}

            </DialogActions>
          </Dialog>
          <Dialog
            open={ProAllocateModal || prjallocation}
            onClose={() => AllocateClose()}
            className="mainbox"
            maxWidth="md"
            fullWidth={true}
            // style={{ height: 900 }}
          >
            <DialogTitle>
              <Row
                className="mainbox "
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={10} md={10}>
                  <div>
                    <label
                      style={{
                        color: "#2593B8",
                        fontWeight: "bold",
                        marginBottom: "5px",
                      }}
                    >
                      Allocate Project
                    </label>
                    <label
                      className="text-muted pl-2"
                      style={{ fontSize: "12px" }}
                    >
                      (Supports multiple team members allocation)
                    </label>
                  </div>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => AllocateClose()}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ minHeight: 400, alignContent: "center" }}>
              <ProjectAllocation
                projectdetails={projectdetails}
                handleClose={AllocateClose}
                employee={employee}
                ProAllocateModal={ProAllocateModal}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          <Dialog
            open={manageaccess}
            onClose={() => setmanageaccess(false)}
            className="mainbox"
            maxWidth="md"
            fullWidth={true}
            // sx={{ '& .MuiDialog-paper': { width: '1100px' } }}
            // style={{ height: 900 }}
          >
            <DialogTitle>
              <Row
                className="mainbox "
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Col lg={10} md={10}>
                  <div>
                    <label
                      style={{
                        color: "#2593B8",
                        fontWeight: "bold",
                        marginBottom: "5px",
                      }}
                    >
                      Manage Access
                    </label>
                    {/* <label
                      className="text-muted pl-2"
                      style={{ fontSize: "12px" }}
                    >
                  
                    </label> */}
                  </div>
                </Col>
                <IconButton
                  className="d-flex justify-content-end"
                  onClick={() => setmanageaccess(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Row>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ minHeight: 200, alignContent: "center" }}>
              <ManageAccess
                projectdetails={projectdetails}
                handleClose={AllocateClose}
                employee={employee}
                ProAllocateModal={ProAllocateModal}
                setmanageaccess={setmanageaccess}
                manageaccess={manageaccess}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          {inviteuser == true ? (
            <Team inviteuser={inviteuser} setinviteuser={setinviteuser} />
          ) : null}
        </div>
      )}
    </>
  );
};

export default Addnewproject;
